export default __webpack_public_path__ + "static/moving_furniture-ccd3ead9eddffde83f22f3442071c459.jpg";